import * as React from 'react';
import { Icon } from 'semantic-grab-ui/src';
import './warning.scss';

interface Props {
  warnings: string[],
}

const WarningList = (props:Props) => {
  return (
    <div>
      {
        props.warnings.map(
          (w, index)=> (
            <p className="warning-text" key={index}>
              <Icon name="warning sign" color="yellow" /> {w}
            </p>
          )
        )
      }
    </div>
  );
};

export default WarningList;
